const StyledInput = ''

export default StyledInput